import { translateFn } from '../../../../../../../utils/translator.helper';
import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../ui/gzDataTable/types';
import { html, TemplateResult } from 'lit';
import { Inheritance, ModuleId, SectionId } from '@nirvana/shared/dtos/types/policies/common';
import {
  getModuleLabelById,
  getSectionLabelById,
} from '../../../../searchableComponents/searchablePolicyPanel/utils/treeItems';

export enum ColumnKeys {
  MODULE = 'moduleId',
  SECTION = 'sectionId',
  POLICY = 'policyName',
}

export function getTableColumns(): IDataTableColumn[] {
  return [
    {
      key: ColumnKeys.MODULE,
      header: translateFn('Module'),
      columnType: IColumnType.DISPLAY,
      renderer: moduleCellCustomRenderer,
    },
    {
      key: ColumnKeys.SECTION,
      header: translateFn('Section'),
      columnType: IColumnType.DISPLAY,
      renderer: sectionCellCustomRenderer,
    },
    {
      key: ColumnKeys.POLICY,
      header: translateFn('Inherit from'),
      columnType: IColumnType.DISPLAY,
    },
    {
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    },
  ];
}

function moduleCellCustomRenderer(content: ModuleId, column: IDataTableColumn, rowIndex: number): TemplateResult {
  const formattedContent = getModuleLabelById(content);

  return html`
    <gz-tooltip isEllipsis tooltipText="${formattedContent}" class="cell-label">${formattedContent}</gz-tooltip>
  `;
}

function sectionCellCustomRenderer(
  content: SectionId,
  column: IDataTableColumn,
  rowIndex: number,
  editMode: boolean,
  item: Inheritance
): TemplateResult {
  const formattedContent = content ? getSectionLabelById(content, item.moduleId) : '-';

  return html`
    <gz-tooltip isEllipsis tooltipText="${formattedContent}" class="cell-label">${formattedContent}</gz-tooltip>
  `;
}
